var _excluded = ["onInputChange", "onSearchTextChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { ComboBoxNormalized } from '@deephaven/components';
import { useCallback, useRef } from 'react';
import { usePickerProps } from "./utils/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ComboBox(props) {
  var _usePickerProps = usePickerProps(props),
    onInputChangeInternal = _usePickerProps.onInputChange,
    onSearchTextChange = _usePickerProps.onSearchTextChange,
    pickerProps = _objectWithoutProperties(_usePickerProps, _excluded);
  var isOpenRef = useRef(false);
  var inputValueRef = useRef('');
  var onInputChange = useCallback(value => {
    onInputChangeInternal === null || onInputChangeInternal === void 0 || onInputChangeInternal(value);

    // Only apply search text if ComboBox is open.
    if (isOpenRef.current) {
      onSearchTextChange(value);
    }
    // When the ComboBox is closed, `onInputChange` may have been called as a
    // result of user search input, ComboBox selection, or by selected key
    // prop changes. We can't determine the source here, so we clear the search
    // text and store the search value so that the list is unfiltered the next
    // time the ComboBox is opened. We also store the search value so we can
    // re-apply it in `onOpenChange` if the ComboBox is opened by user search
    // input.
    else {
      onSearchTextChange('');
      inputValueRef.current = value;
    }
  }, [onInputChangeInternal, onSearchTextChange]);
  var onOpenChange = useCallback((isOpen, menuTrigger) => {
    var _pickerProps$onOpenCh;
    (_pickerProps$onOpenCh = pickerProps.onOpenChange) === null || _pickerProps$onOpenCh === void 0 || _pickerProps$onOpenCh.call(pickerProps, isOpen);

    // Reset the search text when the ComboBox is closed.
    if (!isOpen) {
      onSearchTextChange('');
    }
    // Restore search text when ComboBox has been opened by user input.
    else if (menuTrigger === 'input') {
      onSearchTextChange(inputValueRef.current);
    }

    // Store the open state so that `onInputChange` has access to it.
    isOpenRef.current = isOpen;
  }, [onSearchTextChange, pickerProps]);
  return /*#__PURE__*/_jsx(ComboBoxNormalized
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _objectSpread(_objectSpread({}, pickerProps), {}, {
    onInputChange: onInputChange,
    onOpenChange: onOpenChange
  }));
}
export default ComboBox;
//# sourceMappingURL=ComboBox.js.map